'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var SessionContext = require('../../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageAdditionalInfoContext = /*#__PURE__*/React__default["default"].createContext(null);
const usePackageAdditionalInfo = () => {
  const context = React.useContext(PackageAdditionalInfoContext);
  if (!context) {
    throw new Error('No context provided for PackageAdditionalInfo provider');
  }
  return context;
};
const PackageAdditionalInfoProvider = _ref => {
  var _currentPackageClaim$;
  let {
    children,
    value: {
      currentPackageClaim,
      currentPackageDetails,
      currentClaimStep,
      translations
    }
  } = _ref;
  const {
    claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing,
    claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing,
    claimsAdditionalInfoConfirmationLabelPackageMissing,
    claimsAdditionalInfoCommentsLabelPackageMissing
  } = translations;
  const {
    state: {
      claimType
    },
    handlePackageClaimDetailUpdate,
    handleNavigateBack
  } = index.useClaimBuilder();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const [comment, setComment] = React.useState((currentPackageClaim === null || currentPackageClaim === void 0 ? void 0 : (_currentPackageClaim$ = currentPackageClaim.additionalInfo) === null || _currentPackageClaim$ === void 0 ? void 0 : _currentPackageClaim$.comment) ?? '');
  const [confirmationChecked, setConfirmationChecked] = React.useState(false);
  const {
    fields
  } = currentClaimStep;
  const commentHelper = (fields.comment.required ? claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing : claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing) ?? '';
  const canProceed = (fields.comment.required ? Boolean(comment) : true) && (fields.confirmation.required ? confirmationChecked : true);
  const handleConfirmationChange = e => {
    if (e.target.checked) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_CHECKBOX,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO,
        page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
        order_number: orderNumber,
        claim_reason: claimType
      });
    }
    setConfirmationChecked(e.target.checked);
  };
  const handleCommentChange = e => setComment(e.target.value);
  const handleSubmit = () => {
    if (!canProceed) return;
    const eventType = comment ? useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_NEXT_COMMENTED : useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_NEXT_NO_COMMENT;
    logEvent({
      event_type: eventType,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handlePackageClaimDetailUpdate({
      update: {
        additionalInfo: {
          comment,
          confirmationChecked
        }
      },
      step: index.ClaimStepId.ADDITIONAL_INFO
    });

    // Additional info is the first step. If it's the only step, the item is getting added to the claim
    const isLastStep = (currentPackageClaim === null || currentPackageClaim === void 0 ? void 0 : currentPackageClaim.claimSteps.length) === 1;
    if (isLastStep) {
      var _currentPackageDetail;
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_added',
        properties: {
          product_id: currentPackageDetails === null || currentPackageDetails === void 0 ? void 0 : currentPackageDetails.trackingNumber,
          sku: currentPackageDetails === null || currentPackageDetails === void 0 ? void 0 : currentPackageDetails.items.map(item => item.sku).join(','),
          name: currentPackageDetails === null || currentPackageDetails === void 0 ? void 0 : (_currentPackageDetail = currentPackageDetails.edd) === null || _currentPackageDetail === void 0 ? void 0 : _currentPackageDetail.begin,
          brand: currentPackageDetails === null || currentPackageDetails === void 0 ? void 0 : currentPackageDetails.status,
          variant: currentPackageDetails === null || currentPackageDetails === void 0 ? void 0 : currentPackageDetails.statusCode,
          extra_properties: [{
            key: 'product_additional_info_comment',
            value: comment
          }, {
            key: 'product_additional_info_confirmation',
            value: confirmationChecked ? 'true' : 'false'
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  };
  const handleBack = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ADDITIONAL_INFO_BACK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleNavigateBack();
  };
  return /*#__PURE__*/React__default["default"].createElement(PackageAdditionalInfoContext.Provider, {
    value: {
      canProceed: canProceed,
      commentHelper: commentHelper,
      commentLabel: claimsAdditionalInfoCommentsLabelPackageMissing,
      confirmationLabel: claimsAdditionalInfoConfirmationLabelPackageMissing ?? '',
      confirmationChecked: confirmationChecked,
      packageDetails: currentPackageDetails,
      claimDetails: currentPackageClaim,
      packageClaimStep: currentClaimStep,
      onConfirmationChange: handleConfirmationChange,
      comment: comment,
      onCommentChange: handleCommentChange,
      onSubmit: handleSubmit,
      onBack: handleBack
    }
  }, children);
};

exports.PackageAdditionalInfoContext = PackageAdditionalInfoContext;
exports.PackageAdditionalInfoProvider = PackageAdditionalInfoProvider;
exports.usePackageAdditionalInfo = usePackageAdditionalInfo;
